<template>
  <Btn :label="labelComputed" icon="mdi-download" @click="onClickDownload" :disabled="disabled" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn.vue'
import moment from 'moment'

export default {
  name: 'BtnCsvSearchDownload',

  components: { Btn },

  props: {
    label: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    fileTitle: {
      type: String,
      required: true,
    },
  },
  computed: {
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0075')
      },
    },
  },
  methods: {
    onClickDownload() {
      this.$emit('search')
    },
    downloadCsv(items) {
      const csv = this.$papa.unparse(items, {
        // 完全に空の行、解析後に空白しかない行はスキップする
        skipEmptyLines: 'greedy',
      })
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let blob = new Blob([bom, csv], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      const nowDatetime = moment().format('YYYYMMDDHHmmss')
      link.download = `${this.fileTitle}_${nowDatetime}.csv`
      link.click()
    },
  },
}
</script>
